import { useState, useCallback } from 'react'

import { authHeader, notifyError, notifySuccess } from '../../api/'
import { languageConstants as LC } from '../../constants/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

export const useInsertMissingSensorData = () => {
  const [isLoading, setLoading] = useState(false)
  const [isError, setError] = useState(null)
  const [result, setResult] = useState(null)

  const insertMissingSensorData = useCallback(async data => {
    setError(null)
    setLoading(true)
    try {
      await refreshToken()

      const url = `${REACT_APP_API_URL}/iot/missing-data`
      const options = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ data }),
      }
      const response = await fetch(url, options)
      if (!response.ok) {
        const text = await response.text()
        throw new Error(text || `HTTP ${response.status}`)
      }

      const payload = await response.json()
      setResult(payload)
      notifySuccess(LC.MISSING_SENSORDATA_SUCCESS)
      return payload
    } catch (error) {
      const message = error?.message || 'Fehler beim Speichern'
      setError(message)
      notifyError(message)
      notifyError(LC.MISSING_SENSORDATA_ERROR)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  return { insertMissingSensorData, isLoading, isError, result }
}
